import { roadmapSchema } from '../schema/Roadmap.ts';
import { validateData } from '../utils/utils.ts';
import { api } from './client.ts';
import { getRoadmapUrl } from './constants.ts';

export async function getRoadmap(
  territorySlug: string,
  vehicleId: number | undefined,
  signal?: AbortSignal,
) {
  const { data, status } = await api.get(getRoadmapUrl(territorySlug, vehicleId), { signal });
  if (status === 204 || !data) {
    return null;
  }
  return validateData(roadmapSchema, data, 'Roadmap');
}
